/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module related to i18n and l10n localization.
 */
angular
  .module('filters.i18n', ['ui.format'])
  /**
   * Main filter used for localizing strings.  Use this filter as you would any other angular
   * filter via the
   * {{ "KEY" | i18n }}
   * {{ "KEY" | i18n: scopeVarThatIsArray }}
   *
   * or in code via
   * $filter('i18n')("KEY", ['arg1', 'arg2', ...]);
   *
   * @param {string} key The key used to look up the string in the resource file.
   * @param {Array} tokens An array or tokens to be applied to the resource string using the
   *  angular-ui format filter.
   * @returns The resource string.
   */
  .filter('i18n', [
    '$filter',
    function ($filter) {
      return function (key, tokens) {
        var translations = SBSF.messages;
        if (angular.isArray(tokens)) {
          while (tokens.indexOf(0) !== -1) {
            tokens[tokens.indexOf(0)] = '0';
          }
        } else if (tokens === 0) {
          tokens = '0';
        }

        var result = translations[key] || '???' + key + '???';
        if (tokens) {
          result = $filter('format')(result, tokens);
        }
        return result;
      };
    }
  ]);
